export enum ContactMethod {
  Email = 1,
  Phone
}
